/* =============================================================
 * import
 * ========================================================== */
import {smoother} from "../modules/parallax";
import {eventObserver} from "../modules/eventObserver";
import {disableScrollAnimation} from "../modules/common";
import {gsap} from "gsap/gsap-core";


/* =============================================================
 * export function
 * ========================================================== */
export function before() {
  const $body = document.body;
  $body.classList.remove('top_page');
  $body.classList.add('sub_page');
}


export function after(data) {
  const listeners = [];

  exchangeLangLink();
  mouseStoker();

  const btn = document.querySelectorAll('.totop');
  if (btn.length > 0) {
    btn.forEach(elem => {
      elem.addEventListener('click', toTop, false);
      listeners.push([elem, 'click', toTop, false]);
    });
  }

  // data.container.querySelectorで次ページのコンテンツ情報を取得
  const main = data.container.querySelector('.main_contents'); // 次ページのメインコンテンツ

  if (main) {
    const mainHeight = main.clientHeight;
    const filter = data.container.querySelector('.main_contents_filter');
    if (mainHeight < 1240) {
      filter.style.borderRadius = `2350px / ${mainHeight}px`;
    }
  }
  eventObserver.observeEvents(listeners);
}


/* =============================================================
 * function
 * ========================================================== */

export function toTop() {
  if (disableScrollAnimation()) {
    gsap.to(window, {duration: 1, scrollTo: 0});
  } else {
    smoother.scrollTo(0, true);
  }
}

function mouseStoker() {

  if (!disableScrollAnimation()) {
    const cursor = document.getElementById("cursor");
    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 }; // カーソル要素の座標（リサイズを考慮し初期位置を画面中央に設定）
    const mouse = {x: pos.x, y: pos.y}; // マウスカーソルの座標
    const speed = 0.5; // 0.01〜1 数値が大きほど早い

    const cursorSpecialWrap = document.querySelector(".js-mouseStokerWrap");
    const cursorSpecial = document.querySelectorAll(".js-mouseStoker");
    let cursorSpecialSetX;
    let cursorSpecialSetY;

    // カーソルの座標を設定する
    const cursorSetX = gsap.quickSetter(cursor, "x", "px");
    const cursorSetY = gsap.quickSetter(cursor, "y", "px");

    if (cursorSpecial.length > 0) {
      cursorSpecialSetX = gsap.quickSetter(cursorSpecial, "x", "px");
      cursorSpecialSetY = gsap.quickSetter(cursorSpecial, "y", "px");
    }

    const mouseStokerCallback = (pos, offsetElm) => {

      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      cursorSetX(pos.x);
      cursorSetY(pos.y);

      if (cursorSpecial.length > 0 && offsetElm != null) {
        const offsetElmTop = offsetElm.offsetTop;
        cursorSpecialSetX(pos.x);
        cursorSpecialSetY(pos.y - offsetElmTop);
      }
    };


    // マウスカーソル座標を取得する
    document.addEventListener("mousemove", function(event) {
      mouse.x = event.pageX;
      mouse.y = event.pageY;
    });

    // マウスカーソル座標を更新する
    window.addEventListener("resize", function() {
      pos.x = window.innerWidth / 2;
      pos.y = window.innerHeight / 2;
      gsap.ticker.remove(mouseStokerCallback);
      gsap.ticker.add(function () {
        mouseStokerCallback(pos, cursorSpecialWrap);
      });
    });

    // レンダリングする
    gsap.ticker.add(function () {
      mouseStokerCallback(pos, cursorSpecialWrap);
    });
  }
}

function exchangeLangLink() {
  const currentUrl = window.location.pathname;
  const enLinks = document.querySelectorAll('.lang_link_en');
  const jaLinks = document.querySelectorAll('.lang_link_ja');
  let jaUrl;
  let enUrl;

  if (currentUrl.includes("/en/")) {
    jaUrl = currentUrl.replace("/en/", "/");
    enUrl = currentUrl;
    jaLinks.forEach((link) => {
      link.href = jaUrl;
    });
    enLinks.forEach((link) => {
      link.href = enUrl;
    });
  } else {

    if (currentUrl.includes("/news/")) {
      jaUrl = "/";
      enUrl = "/en/";
    } else {
      jaUrl = currentUrl;
      enUrl = "/en" + currentUrl;
    }

    jaLinks.forEach((link) => {
      link.href = jaUrl;
    });
    enLinks.forEach((link) => {
      link.href = enUrl;
    });
  }
}